import styled from '@emotion/styled';
import { css } from '@emotion/react';

import breakpoints from 'app/styles/constants/breakpoints';
import { endDirection, startDirection } from 'app/styles/selectors/markup';

const { widthSmall } = breakpoints;
const S = {};

S.Selector = styled.div`
  label: Selector;

  display: flex;
  align-items: center;
  width: 100%;
  border: solid 0.125rem var(--colors-black);
  cursor: pointer;
  padding: ${props => (props.isOpened ? '0.5rem' : '0.375rem')} 0.375rem
    0.375rem 0.625rem;
  position: relative;
  border-top: ${props => (props.isOpened ? 'none' : '')};

  ${({ isOpened }) =>
    isOpened &&
    css`
      ${S.Selector.Icon} {
        transform: rotate(270deg);
      }

      ${S.Selector.LanguageList} {
        display: block;
        border-bottom: none;
      }
    `}

  @media (${widthSmall}) {
    width: 11.25rem;
  }
`;

S.Selector.Language = styled.span`
  label: Language;

  flex: 1 1 auto;
  padding-${endDirection}: 0.5rem;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

S.Selector.Icon = styled.svg`
  label: Icon;

  flex: 0 0 auto;
  width: 1.5rem;
  height: 1.5rem;
  transition: transform 0.1s ease-in-out;
  transform: rotate(90deg);
`;

S.Selector.LanguageList = styled.ul`
  label: LanguageList;

  position: absolute;
  bottom: 100%;
  border: solid 0.125rem var(--colors-black);
  ${endDirection}: -0.125rem;
  ${startDirection}: -0.125rem;
  z-index: var(--z-index-dropdown);
  display: none;
  background-color: var(--colors-white);
`;

S.Selector.LanguageItem = styled.span`
  label: LanguageItem;

  display: block;
  padding: 0.5rem 0.75rem;
  color: var(--colors-silver-chalice);

  &:hover {
    color: var(--colors-black);
  }
`;

export default S;
